import { ActivatedRoute, Router } from '@angular/router';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfigSettingDto } from 'src/app/model/business/ConfigSettingDto';
import { SessionService } from 'src/app/session-service.service';

@Component({
  selector: 'app-idin-verification-error-page',
  templateUrl: './idin-verification-error-page.component.html',
  styleUrls: ['./idin-verification-error-page.component.css'],
})
export class IdinVerificationErrorPageComponent implements OnInit {
  relativePath: string;

  @Output()
  resetApplication = new EventEmitter();

  constructor(
    private sessionService: SessionService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    const {
      productType,
      locale,
    } = this.activatedRoute.snapshot.params;

    this.relativePath = locale ?
      `/${locale}/${productType}` :
      `/${productType}`;
  }

  ngOnInit(): void {}

  get configSettings(): ConfigSettingDto {
    return this.sessionService.getConfigSettingsDto();
  }

  calculationPage(): void {
    this.resetApplication.emit();
    this.router.navigate([`${this.relativePath}/calculation`, this.sessionService.getIntermediaryId()]);
  }
}
